const regEx = {
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,100}$/i,
    nonEmpty: /^(?!\s*$).+/,
    password: /^.{5,128}$/,
    url: /^(.+)$/,
    zipcode: /^([-\s]*[a-zA-z\d]?[-\s]*){0,9}$/,
};

export const checkString = ({
    minLength = 0,
    maxLength = 10000,
}: {
    minLength?: number;
    maxLength?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
}) => (value: any): boolean => {
    if (typeof value !== 'string') {
        return false;
    }
    return value.length >= minLength && value.length <= maxLength;
};

type Validator = (value: string) => boolean;

export const isNumericString: Validator = value =>
    checkString({ minLength: 1 })(value) && !isNaN(+value);

export const isValidEmail: Validator = value => regEx.email.test(value);
export const isValidPassword: Validator = value => regEx.password.test(value);
export const isValidUrl: Validator = value => regEx.url.test(value);
export const isValidZipcode: Validator = value => regEx.zipcode.test(value);
export const noRestrictions = (): boolean => true;

export function isNonEmpty(value: string): boolean {
    return regEx.nonEmpty.test(value);
}

export const all = (...validators: Validator[]) => (value: string): boolean => {
    for (let i = 0; i < validators.length; i++) {
        if (!validators[i](value)) {
            return false;
        }
    }

    return true;
};

export const oneOf = (...validators: Validator[]) => (value: string): boolean => {
    for (let i = 0; i < validators.length; i++) {
        if (validators[i](value)) {
            return true;
        }
    }

    return false;
};
